import { render, staticRenderFns } from "./GTeacherRegistration.vue?vue&type=template&id=4e9d76be&scoped=true&"
import script from "./GTeacherRegistration.vue?vue&type=script&lang=ts&"
export * from "./GTeacherRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./GTeacherRegistration.vue?vue&type=style&index=0&id=4e9d76be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d76be",
  null
  
)

export default component.exports